import * as React from 'react';

import { cn } from '@eliadmin/core/src/utils/style-utils';
import type { VariantProps } from 'class-variance-authority';
import { cva } from 'class-variance-authority';

const textareaVariants = cva(
  cn(
    'flex min-h-[60px] w-full rounded-md px-3 py-2 text-sm shadow-sm placeholder:text-muted-foreground',
    'focus-visible:outline-none',
  ),
  {
    variants: {
      variant: {
        outlined: ['bg-background border', 'ea-textarea__outlined'],
        filled: ['bg-input border-transparent', 'ea-textarea__filled'],
      },
      rounded: {
        default: 'rounded-lg',
        none: 'rounded-none',
      },
    },
    defaultVariants: {
      rounded: 'default',
      variant: 'filled',
    },
  },
);

export type TextareaProps = React.TextareaHTMLAttributes<HTMLTextAreaElement> &
  VariantProps<typeof textareaVariants> & {
    className?: string;
    classNames?: string;
  };

const Textarea = React.forwardRef<HTMLTextAreaElement, TextareaProps>(
  ({ className, classNames, ...props }, ref) => {
    return (
      <textarea
        style={{ resize: 'none' }}
        className={cn(
          textareaVariants({
            variant: props.variant,
            rounded: props.rounded,
            className: cn(
              'ea-textarea bg-input',
              props['aria-invalid'] && 'ea-textarea--invalid border-destructive text-destructive',
              className,
              classNames,
            ),
          }),
        )}
        ref={ref}
        {...props}
      />
    );
  },
);
Textarea.displayName = 'Textarea';

export { Textarea };
